import { createContext, useContext } from 'react'

import { definitions } from 'api/generated/photo'

export type PhotoViewerContextData = {
  photos: definitions['OmniAlbumPhoto'][]
  showArrows: boolean
  photoBaseUrl: string
  currentIndex: number
}

export const PhotoViewerContext = createContext<PhotoViewerContextData | null>(
  null
)

export const usePhotoViewerContext = () => {
  const value = useContext(PhotoViewerContext)

  if (value === null) {
    throw new Error(
      'usePhotoViewerContext has to be used within <PhotoViewerContext.Provider>'
    )
  }

  return value
}
